import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { timer } from 'rxjs/observable/timer';

import { SearchSuggestion } from '../models/Datatables.model';

@Component({
  selector: 'app-search-suggestions',
  templateUrl: './search-suggestions.component.html',
  styleUrls: ['./search-suggestions.component.css']
})
export class SearchSuggestionsComponent implements OnInit{
  private _searchInput$: Subject<string> = new BehaviorSubject(null);
  @Input() suggestions: SearchSuggestion[] = [];
  _filteredSuggestions$: Observable<SearchSuggestion[]>;

  @Input() set searchInput(value: string) {
    this._searchInput$.next(value);
  }

  @Output() selectSuggestion: EventEmitter<string> = new EventEmitter(null);

  ngOnInit() {
    this._filteredSuggestions$ = this._searchInput$
      .debounce(input => input && input.length > 1 ? timer(350) : timer(0))
      .distinctUntilChanged()
      .map(input => this.filterSuggestions(input));
  }

  filterSuggestions(input: string): SearchSuggestion[] {
    if (!input || input.length < 2 || !this.suggestions) return null;

    let size: number = 0;
    const needle = input.toLowerCase().trim();
    const suggestions = this.suggestions.filter(suggestion => {
      if (size > 6 || typeof suggestion.value !== 'string') return false;

      const haystack: string = suggestion.value.toLowerCase();
      if (haystack.includes(needle)) {
        size++;
        return true;
      }
    });

    return suggestions.length ? suggestions : null;
  }

  onSuggestionClick(suggestion: string) {
    this.selectSuggestion.emit(suggestion.toLowerCase());
  }

  hide() {
    setTimeout(() => {
      this._searchInput$.next('');
    },100);
  }

  getProp(prop: string) {
    return prop.replace('_', ' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/search-suggestions/search-suggestions.component.ts